import React, {useState, useEffect, useContext} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select, TimePicker} from 'antd';
import {AuthContext} from "../../../config/AuthContext";
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {User} from "../../../model/root/User";
import dayjs from "dayjs";
import ControlHorari from "../../../model/root/ControlHorari";
import toast, { Toaster } from 'react-hot-toast';
import {GetHoraris} from "../../../dao/root/GetHoraris";


interface ControlHorariModalProps {
    element: ControlHorari;
    visible: boolean;
    onClose: (controlHorari: ControlHorari, guardar: boolean) => void;
    options: { label: string; value: string; }[];
    llocsTreball: { label: string; value: string; }[];
    usuaris: User[] | undefined;
    update: boolean;
}

const ControlHorariModal: React.FC<ControlHorariModalProps> = ({
                                                                element,
                                                                visible,
                                                                options,
                                                                onClose,
                                                                update,
                                                                llocsTreball
                                                            }) => {

    const [form] = Form.useForm();
    const format = 'HH:mm';
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    useEffect(() => {
        if (visible) {
            checkDades() 
        }
    }, [visible]);

    async function checkDades() {
        //cargar horari
        const horarisData = await GetHoraris(page);
        setHorariOptions(horarisData || []);
    }
    
    const handleSubmit = () => {
        const formData = form.getFieldsValue();
        formData.entrada = formData.entrada ? dayjs(formData.entrada).format('HH:mm') : null;
        formData.sortida = formData.sortida ? dayjs(formData.sortida).format('HH:mm') : null;
        if (formData.entrada !== null && formData.sortida !== null) {
            const controlHorari = new ControlHorari(formData.id, formData.id, (idUsuari), formData.nom,
            formData.entrada, formData.sortida, formData.estat, (idLloc), formData.lloc);


            console.log(">>>>>"+JSON.stringify(controlHorari));
            onClose(controlHorari, true);
        } else {
           toast('Falten dades.');
        }

    };
     const [options3, setOptions3] = useState<{ label: string; value: string; }[]>([{
            label: "",
            value: ""
        }]);
    function setHorariOptions(horaris: any[]) {
        if (horaris && horaris?.length) {
            const options = horaris.map(horari => ({
                label: `${horari.nom}: ${horari.entrada} - ${horari.sortida} `,
                value: horari.id + ""
            }));
            setOptions3(options);
        }
    }

    const [idLloc, setIdLloc] = useState(element.id_lloc);
    const [idUsuari, setIdUsuari] = useState(element.id_usuario);

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(new ControlHorari(), false);
    };

    return (
        <>
            <Toaster />
            <Modal
                title="Editar Control Horari"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={500}
            >
                <Form form={form} initialValues={element}>
                    <Row >
                        <Col span={24}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Nombre" name="nom" required>
                                <Select disabled={update}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={options}
                                        onChange={(text, index) => {
                                            setIdUsuari(text);
                                        }}
                                />
                            </Form.Item>
                            <Form.Item label="Estado" name="estat" required>
                                <Select>
                                    <option value={0}>actiu</option>
                                    <option value={-1}>inactiu</option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Lloc" name="lloc" required>
                                <Select showSearch
                                        placeholder="Selecciona Lloc de treball"
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={llocsTreball}
                                        onChange={(text, index) => {
                                            setIdLloc(text);
                                        }}
                                />
                            </Form.Item>
                            <Form.Item label="Horari" name="id_horari" required>
                                    <Select
                                        showSearch
                                        placeholder="Selecciona l'horari"
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={[
                                                { label: 'Personalitzar horari', value: '0' },
                                                    ...options3
                                                ]}
                                        onChange={(value) => {
                                        form.setFieldValue("id_horari", value);
                                            setIdLloc(value); // si aún lo usas para algo más
                                        }}
                                    />
                            </Form.Item>

                        {form.getFieldValue("id_horari") === "0" && (
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Entrada"
                                            name="entrada"
                                        >
                                            <TimePicker format="HH:mm"  />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Sortida"
                                            name="sortida"
                                        >
                                            <TimePicker format="HH:mm"  />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default ControlHorariModal;
